module.exports = __webpack_public_path__ + "static/media/parikrama.321ce129.png";